/**
 * Toasts. A module-level bus so any code — a mutation's onError, the 401 guard — can raise one
 * without a hook. <ToastViewport> (src/ui/Toast.jsx) is the one listener.
 *
 *   toast('Payout approved', { tone: 'success', detail: 'PO-2291 · UGX 400,800,000' })
 *   toast('Session expired', { tone: 'error', sticky: true, action: { label: 'Sign in', onClick } })
 */
const listeners = new Set();
let seq = 0;

export const TOAST_BUS = { suppressErrors: false };

export function toast(title, { tone = 'info', detail, action, sticky = false } = {}) {
  if (tone === 'error' && TOAST_BUS.suppressErrors) return null;
  const item = { id: ++seq, title, tone, detail, action, sticky: sticky || !!action };
  listeners.forEach((fn) => fn({ type: 'add', item }));
  return item.id;
}

export const dismissToast = (id) => listeners.forEach((fn) => fn({ type: 'remove', id }));

export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
